import { Component } from '@angular/core';

@Component({
    selector: 'app-scroll-to-top',
    standalone: false,
    templateUrl: './scroll-to-top.component.html',
    styleUrl: './scroll-to-top.component.scss'
})
export class ScrollToTopComponent {

  scrollToTop(){
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }
}